import { Link } from "react-router-dom";
import ScrollRow from "@components/layout/ScrollRow";

export default function ComingSoonSection({ items }) {
  return (
    <section className="home-coming-row" style={{ padding: "28px 52px 48px" }}>
      <div
        style={{
          fontSize: 32,
          fontWeight: 600,
          color: "#fff",
          textTransform: "uppercase",
          marginBottom: 14,
        }}
        className="jost-s"
      >
        Скоро на SMOTRI
      </div>

      <ScrollRow cardStyle="calc((100% - 50px) / 3)">
        {items.map((item) => {
          const Wrapper = item.href ? Link : "div";
          const wrapperProps = item.href ? { to: item.href } : {};

          return (
            <Wrapper
              key={item.id}
              {...wrapperProps}
              style={{
                position: "relative",
                width: "100%",
                height: 328,
                border: "1px solid rgba(255, 255, 255, 0.12)",
                borderRadius: 12,
                overflow: "hidden",
                background: "#111",
                color: "inherit",
                cursor: item.href ? "pointer" : "default",
                display: "block",
                textDecoration: "none",
              }}
            >
            <img
              src={item.img}
              alt={item.title}
              style={{
                position: "absolute",
                inset: 0,
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
            <div
              style={{
                position: "absolute",
                top: -2,
                left: -1,
                width: 220,
                height: 220,
                background: "#000",
                clipPath: "polygon(0 0, 100% 0, 0 100%)",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "flex-start",
                padding: "20px 18px 12px",
              }}
            >
              <div
                style={{
                  width: 84,
                  fontFamily: "'Jost', sans-serif",
                  fontSize: 70,
                  fontWeight: 500,
                  fontStyle: "italic",
                  lineHeight: "110%",
                  letterSpacing: "-0.04em",
                  textTransform: "uppercase",
                  color: "#FFFFFF",
                }}
              >
                {item.date}
              </div>
              <div
                style={{
                  fontFamily: "'Jost', sans-serif",
                  fontSize: 17,
                  fontWeight: 500,
                  letterSpacing: "-0.04em",
                  color: "#FFFFFF",
                  fontStyle: "italic",
                  lineHeight: "110%",
                  textTransform: "uppercase",
                }}
              >
                {item.month}
              </div>
            </div>
            <div
              style={{
                position: "absolute",
                inset: 0,
                zIndex: 2,
                background:
                  "linear-gradient(to top, rgba(0,0,0,.5) 0%, transparent 60%)",
              }}
            />
            {item.logo && (
              <img
                src={item.logo}
                alt=""
                aria-hidden="true"
                style={{
                  position: "absolute",
                  left: 24,
                  bottom: 24,
                  zIndex: 4,
                  width: 164,
                  maxHeight: 145,
                  objectFit: "contain",
                  objectPosition: "left bottom",
                  filter: "drop-shadow(0 8px 16px rgba(0,0,0,0.45))",
                  pointerEvents: "none",
                }}
              />
            )}
            </Wrapper>
          );
        })}
      </ScrollRow>
    </section>
  );
}
